export default __webpack_public_path__ + "static/media/Nav-News.a98da415.svg";